// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3-w5W","row":"Node_row__nZx9m","label":"Node_label__jZJU4","footer":"Node_footer__2UZKI"};